import { FolderSvg, PartsSvg } from "@/components/Icon/Icon";
import { Thumbnail } from "@/components/Thumbnail/Thumbnail"; // Import Thumbnail component
import { selectAreCaseUploadThumbnailsAvailable, selectAreCaseUploadThumbnailsLoading, selectCaseUpload } from "@/store/slices/casesSlice";
import { RootState } from "@/store/store";
import { getCombinedThumbnailFromIndexedDB, getThumbnailFromIndexedDB } from "@/utils/uploadsCache";
import { Box } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";

interface ScanThumbnailProps {
  caseId: number;
  scanId?: string;
}

export const ScanThumbnail: FC<ScanThumbnailProps> = ({ caseId, scanId }) => {
  const areThumbnailsAvailable = useSelector((state: RootState) => selectAreCaseUploadThumbnailsAvailable(state, caseId));
  const areThumbnailsLoading = useSelector((state: RootState) => selectAreCaseUploadThumbnailsLoading(state, caseId));
  const numScans = useSelector((state: RootState) => selectCaseUpload(state, caseId)?.scans?.length);
  const [imageUrl, setImageUrl] = useState<string | undefined>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    if (areThumbnailsLoading) {
      setLoading(true);
      setImageUrl(undefined);
      setError(false);
      return;
    }
    if (!areThumbnailsAvailable) {
      setImageUrl(undefined);
      setError(false);
      return;
    }
    setLoading(true);

    const fetchDentalCases = async () => {
      const thumbnail = scanId === undefined ? await getCombinedThumbnailFromIndexedDB(caseId) : await getThumbnailFromIndexedDB(scanId);

      if (thumbnail && thumbnail.data != null) {
        const blob = new Blob([thumbnail.data], { type: `image/${thumbnail.type}` });
        const thumbnailURL = URL.createObjectURL(blob);
        setImageUrl(thumbnailURL);
      } else {
        setImageUrl(undefined);
        setError(true);
      }

      setLoading(false);
    };

    fetchDentalCases();
  }, [caseId, scanId, areThumbnailsAvailable, areThumbnailsLoading]);

  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "50px",
        height: "50px",
        flexShrink: 0,
        padding: "0.5em",
        boxSizing: "border-box"
      }}
    >
      <Thumbnail
        imageUrl={imageUrl}
        loading={loading && !error && numScans != 0}
        fallback={
          scanId === undefined ? <FolderSvg width={40} height={40} opacity={0.3} /> : <PartsSvg width={40} height={40} opacity={0.3} />
        }
      />
    </Box>
  );
};
